/**
 * ConsumerTokenTag automatically generated by SDKgen please do not edit this file manually
 * {@link https://sdkgen.app}
 */

import {TagAbstract, HttpRequest} from "sdkgen-client"
import {ClientException, UnknownStatusCodeException} from "sdkgen-client";

import {CommonMessage} from "./CommonMessage";
import {CommonMessageException} from "./CommonMessageException";
import {ConsumerToken} from "./ConsumerToken";
import {ConsumerTokenAccessToken} from "./ConsumerTokenAccessToken";
import {ConsumerTokenCollection} from "./ConsumerTokenCollection";
import {ConsumerTokenCreate} from "./ConsumerTokenCreate";
import {ConsumerTokenUpdate} from "./ConsumerTokenUpdate";

export class ConsumerTokenTag extends TagAbstract {
    /**
     * Creates a new token for the authenticated user
     *
     * @returns {Promise<ConsumerTokenAccessToken>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async create(payload: ConsumerTokenCreate): Promise<ConsumerTokenAccessToken> {
        const url = this.parser.url('/consumer/token', {
        });

        let request: HttpRequest = {
            url: url,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            params: this.parser.query({
            }, [
            ]),
            data: payload
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as ConsumerTokenAccessToken;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }
    /**
     * Deletes an existing token for the authenticated user
     *
     * @returns {Promise<CommonMessage>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async delete(tokenId: string): Promise<CommonMessage> {
        const url = this.parser.url('/consumer/token/$token_id<[0-9]+|^~>', {
            'token_id': tokenId,
        });

        let request: HttpRequest = {
            url: url,
            method: 'DELETE',
            headers: {
            },
            params: this.parser.query({
            }, [
            ]),
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as CommonMessage;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }
    /**
     * Returns a specific token for the authenticated user
     *
     * @returns {Promise<ConsumerToken>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async get(tokenId: string): Promise<ConsumerToken> {
        const url = this.parser.url('/consumer/token/$token_id<[0-9]+|^~>', {
            'token_id': tokenId,
        });

        let request: HttpRequest = {
            url: url,
            method: 'GET',
            headers: {
            },
            params: this.parser.query({
            }, [
            ]),
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as ConsumerToken;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }
    /**
     * Returns a paginated list of tokens which are assigned to the authenticated user
     *
     * @returns {Promise<ConsumerTokenCollection>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async getAll(startIndex?: number, count?: number, search?: string): Promise<ConsumerTokenCollection> {
        const url = this.parser.url('/consumer/token', {
        });

        let request: HttpRequest = {
            url: url,
            method: 'GET',
            headers: {
            },
            params: this.parser.query({
                'startIndex': startIndex,
                'count': count,
                'search': search,
            }, [
            ]),
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as ConsumerTokenCollection;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }
    /**
     * Updates an existing token for the authenticated user
     *
     * @returns {Promise<ConsumerTokenAccessToken>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async update(tokenId: string, payload: ConsumerTokenUpdate): Promise<ConsumerTokenAccessToken> {
        const url = this.parser.url('/consumer/token/$token_id<[0-9]+|^~>', {
            'token_id': tokenId,
        });

        let request: HttpRequest = {
            url: url,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            params: this.parser.query({
            }, [
            ]),
            data: payload
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as ConsumerTokenAccessToken;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }



}
